export const loadCSS = () => {
    if (process.env.REACT_APP_COUNTRY === 'AU') {
        import ("pr-utility/sass/style.scss");
    } else if(process.env.REACT_APP_COUNTRY === 'US'){
        import ("pr-utility/sass/style.scss");
    }
}